import { render, staticRenderFns } from "./questionClass.vue?vue&type=template&id=78679fd0&scoped=true&"
import script from "./questionClass.vue?vue&type=script&lang=js&"
export * from "./questionClass.vue?vue&type=script&lang=js&"
import style0 from "./questionClass.vue?vue&type=style&index=0&id=78679fd0&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78679fd0",
  null
  
)

export default component.exports